import React, { HTMLAttributes } from "react";

import { FooterContainer } from "./EmptySlate.styles";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface EmptySlateFooterProps extends HTMLAttributes<HTMLDivElement> {}

export const EmptySlateFooter = ({ children, ...rest }) => {
  return <FooterContainer {...rest}>{children}</FooterContainer>;
};

EmptySlateFooter.displayName = "EmptySlateFooter";
